import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_right_deep",
  "use": "icon-icon_arrow_right_deep-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-icon_arrow_right_deep\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h18v18H0z\" /><path fill=\"#5E6065\" fill-rule=\"nonzero\" d=\"M9.879 9 6.167 5.287l1.06-1.06L12 9l-4.773 4.773-1.06-1.06z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol